import { useLoras } from "@features/loras/use-loras";
import { usePopularLoras } from "@features/popular/use-popular";
import { useUser } from "@features/user/use-user";
import { useEffectPlease, useNavigateAlt } from "@features/utils";
import posthog from "posthog-js";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { GreetingStep } from "./parts/greetings";

enum WelcomeStep {
  Greeting,
  Interests,
  ReferralSource,
  SelectSubject,
  SelectAction,
}

export const Welcome = () => {
  const navigate = useNavigateAlt();
  const { user, setAnalytics } = useUser();
  const { site } = useParams();
  const { loras } = useLoras();

  const greetingsLocalKey = "persist_passed_greetings_" + user.data?.id;

  const { data: popularLoras } = usePopularLoras("lora_model");
  const [step, setStep] = useState<WelcomeStep>(
    localStorage.getItem(greetingsLocalKey)
      ? WelcomeStep.SelectSubject
      : WelcomeStep.Greeting
  );

  useEffectPlease(() => {
    window.scrollTo(0, 0);
  }, [step]);

  useEffectPlease(() => {
    // If user has already passed greetings, skip to select subject
    if (step === WelcomeStep.SelectSubject) {
      navigate(`/${site || "portraits"}/lora/model`, {
        state: { userName: user.data?.name, fromWelcome: true },
      });
    }
  }, [step]);

  // Get popular models (max 4)
  const popularModels = popularLoras?.pages[0]?.slice?.(0, 4) || [];
  // Get user models if any (max 4)
  const userModels = (loras.data || [])
    .filter((lora) => lora.type === "model" && lora.status !== "failed")
    .slice(0, 4);

  // Display models - prioritize user models then fill with popular ones
  const displayModels = [...userModels];
  if (displayModels.length < 4) {
    const remainingSlots = 4 - displayModels.length;
    popularModels.slice(0, remainingSlots).forEach((model) => {
      // Only add if not already in the list
      if (!displayModels.find((m) => m.id === model.id)) {
        displayModels.push(model);
      }
    });
  }

  return (
    <div className="h-full flex flex-col">
      {step === WelcomeStep.Greeting && (
        <GreetingStep
          onContinue={(features, sources) => {
            setAnalytics({
              features,
              sources,
            });
            localStorage.setItem(greetingsLocalKey, "1");
            posthog.capture("passed_welcome_greeting");
            setStep(WelcomeStep.SelectSubject);
          }}
          userName={user.data?.name}
        />
      )}
    </div>
  );
};
